import { parseISO } from 'date-fns';

const GRACE_PERIOD_MS = 15 * 60 * 1000;
const ZONED_DATETIME_PATTERN =
  /^\d{4}-\d{2}-\d{2}T[\d:.]+(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)$/;

/** Returns an absolute start time, independent of the provider's timezone. */
export function getAppointmentStartTime(
  appointmentDate: string | null | undefined,
): number | null {
  if (!appointmentDate) return null;

  // Healthie: "2024-04-01 11:09:04 +0200" → "2024-04-01T11:09:04+0200".
  // Use explicit ISO parsing rather than browser-dependent native parsing.
  const normalized = appointmentDate.trim().replace(' ', 'T').replace(' ', '');
  if (!ZONED_DATETIME_PATTERN.test(normalized)) return null;

  const start = parseISO(normalized).getTime();
  // Unlike sanitizeHealthieDate, never replace an invalid date with "now".
  return Number.isFinite(start) ? start : null;
}

/** Returns an absolute deadline, independent of the provider's timezone. */
export function getAppointmentGracePeriodEnd(
  appointmentDate: string | null | undefined,
): number | null {
  const start = getAppointmentStartTime(appointmentDate);
  return start === null ? null : start + GRACE_PERIOD_MS;
}
